import { Attr, BaseSchema, ModelSchema } from './helpers'

@ModelSchema({
  name: 'url',
  description: 'Owned by either a user or org as their username',
  version: 0,
  required: [],
  sync: false,
})
export class UrlSchema extends BaseSchema {
  @Attr({ type: 'boolean' }) keyword: boolean
  @Attr({ type: 'string' }) path: string
}
